<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 511.988 511.988"
>
  <path
    d="m316.868 34.358-31.25-31.249c-2-2-4.719-3.109-7.547-3.109h-44.17a10.665 10.665 0 0 0-7.547 3.109l-31.249 31.249c-2 2-3.109 4.719-3.109 7.547v44.171c0 2.828 1.109 5.547 3.109 7.547l31.249 31.249c2 2 4.719 3.109 7.547 3.109h44.17c2.828 0 5.547-1.109 7.547-3.109l31.25-31.249c2-2 3.125-4.719 3.125-7.547V41.905c0-2.844-1.125-5.547-3.125-7.547zm-60.874 50.968c-11.765 0-21.343-9.578-21.343-21.327 0-11.766 9.578-21.344 21.343-21.344 11.75 0 21.327 9.578 21.327 21.344 0 11.749-9.577 21.327-21.327 21.327z"
    fill="#4a89dc"
  />
  <path
    d="M319.993 149.324H191.996a10.657 10.657 0 0 0-10.672 10.672v42.655c0 5.891 4.766 10.672 10.672 10.672h127.997c5.891 0 10.656-4.781 10.656-10.672v-42.655c0-5.906-4.765-10.672-10.656-10.672z"
    fill="#434a54"
  />
  <path
    d="M373.319 234.65h-10.672v-31.999a10.648 10.648 0 0 0-10.656-10.655H159.996c-5.906 0-10.672 4.765-10.672 10.655v31.999h-10.671c-5.891 0-10.656 4.781-10.656 10.672v255.994c0 5.891 4.766 10.672 10.656 10.672h234.666c5.891 0 10.672-4.781 10.672-10.672V245.322c0-5.89-4.781-10.672-10.672-10.672z"
    fill="#e6e9ed"
  />
  <path
    d="M149.325 234.65h53.327c5.891 0 10.672-4.765 10.672-10.655 0-5.906-4.781-10.672-10.672-10.672h-53.327v21.327zM297.884 223.995a10.648 10.648 0 0 0 10.656 10.655h54.107v-21.327H308.54c-5.891 0-10.656 4.766-10.656 10.672z"
    fill="#ccd1d9"
  />
  <path
    d="m348.867 131.106-21.343-21.327c-2-2-4.703-3.125-7.531-3.125H191.996a10.653 10.653 0 0 0-7.547 3.125l-21.344 21.327c-4.156 4.172-4.156 10.922 0 15.094l21.344 21.327c2 2 4.703 3.125 7.547 3.125h127.997c2.828 0 5.531-1.125 7.531-3.125l21.343-21.327c4.155-4.172 4.155-10.922 0-15.094zM255.994 330.648c-43.764-43.765-107.248-15.219-127.997-3.969v174.637c0 5.891 4.766 10.672 10.656 10.672h234.666c5.891 0 10.672-4.781 10.672-10.672V334.617c-20.766 11.25-84.248 39.796-127.997-3.969z"
    fill="#5d9cec"
  />
  <path
    d="M373.319 234.65h-10.672v-31.999a10.648 10.648 0 0 0-10.656-10.655h-21.342c5.89 0 10.671 4.765 10.671 10.655v31.999h10.671c5.891 0 10.656 4.781 10.656 10.672v255.994c0 5.891-4.766 10.672-10.656 10.672h21.328c5.891 0 10.672-4.781 10.672-10.672V245.322c0-5.89-4.781-10.672-10.672-10.672z"
    fill="#ffffff33"
  />
  <path
    d="M195.121 397.771a10.667 10.667 0 0 0 0 15.095c4.156 4.156 10.906 4.156 15.078 0a10.667 10.667 0 0 0 0-15.095c-4.172-4.156-10.922-4.156-15.078 0zM173.777 440.443c-4.156 4.156-4.156 10.922 0 15.078a10.668 10.668 0 0 0 15.094 0c4.156-4.156 4.156-10.922 0-15.078a10.666 10.666 0 0 0-15.094 0z"
    fill="#4a89dc"
  />
</svg>
